/**
 * Single source of truth for landing-page <title> and <meta description>.
 *
 * These values are consumed BOTH by the React <SEO> component (client-side,
 * react-helmet-async) AND by scripts/generate-static-pages.js, which bakes them
 * into the pre-rendered HTML that Googlebot actually reads.
 *
 * Before this file existed the two had drifted: cityData.js said
 * "Rishta in Lahore — Find Verified Lahore Matrimonial Profiles" while the
 * pre-renderer emitted "Rishta in Lahore — Verified Profiles | Select Proposal".
 * Google only ever saw the second one, so edits to cityData.js had no SEO effect.
 * Keep meta copy HERE and nowhere else.
 *
 * Rules of thumb:
 *   - title       <= 60 characters (Google truncates beyond ~60)
 *   - description <= 155 characters (previous city descriptions ran to 186 and
 *                    were cut off mid-sentence in search results)
 *
 * CommonJS on purpose: the Node pre-render script requires() this file.
 */

const CITY_META = {
  "lahore": {
    title: "Free Rishta in Lahore — Verified Profiles | Select Proposal",
    description: "Free rishta in Lahore. Browse verified Lahore matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "karachi": {
    title: "Free Rishta in Karachi — Verified Rishtay Online",
    description: "Karachi rishtay, free to browse. Verified profiles from every community with education, profession, age and family details. No agent, no fee to search.",
  },
  "islamabad": {
    title: "Free Rishta in Islamabad — Verified Profiles",
    description: "Free rishta in Islamabad and Rawalpindi. Browse verified Islamabad matrimonial profiles by education, profession, age and family background.",
  },
  "rawalpindi": {
    title: "Free Rishta in Rawalpindi — Verified Profiles",
    description: "Free rishta in Rawalpindi. Browse verified Rawalpindi matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "faisalabad": {
    title: "Free Rishta in Faisalabad — Verified Profiles",
    description: "Free rishta in Faisalabad. Browse verified Faisalabad matrimonial profiles by education, profession, age and family background.",
  },
  "multan": {
    title: "Free Rishta in Multan — Verified Profiles | Select Proposal",
    description: "Free rishta in Multan. Browse verified Multan matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "peshawar": {
    title: "Free Rishta in Peshawar — Verified Profiles",
    description: "Free Peshawar rishta service. Browse verified Peshawar and Mardan matrimonial profiles by education, profession, age and family background.",
  },
  "quetta": {
    title: "Free Rishta in Quetta — Verified Profiles | Select Proposal",
    description: "Free rishta in Quetta. Browse verified Quetta matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "sialkot": {
    title: "Free Rishta in Sialkot — Verified Profiles | Select Proposal",
    description: "Free rishta in Sialkot. Browse verified Sialkot matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "gujranwala": {
    title: "Free Rishta in Gujranwala — Verified Profiles",
    description: "Free rishta in Gujranwala. Browse verified Gujranwala matrimonial profiles by education, profession, age and family background.",
  },
  "abbottabad": {
    title: "Free Rishta in Abbottabad — Verified Profiles",
    description: "Free rishta in Abbottabad. Browse verified Abbottabad matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "bahawalpur": {
    title: "Free Rishta in Bahawalpur — Verified Profiles",
    description: "Free rishta in Bahawalpur. Browse verified Bahawalpur matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "hyderabad": {
    title: "Free Rishta in Hyderabad, Sindh — Verified Rishtay",
    description: "Hyderabad rishtay, free to browse. Verified profiles with education, profession, age and family details. Manually reviewed, no agent involved.",
  },
  "sargodha": {
    title: "Free Rishta in Sargodha — Verified Profiles",
    description: "Free rishta in Sargodha. Browse verified Sargodha matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "sukkur": {
    title: "Free Rishta in Sukkur — Verified Profiles | Select Proposal",
    description: "Free rishta in Sukkur. Browse verified Sukkur matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "mardan": {
    title: "Free Rishta in Mardan — Verified Profiles | Select Proposal",
    description: "Free rishta in Mardan. Browse verified Mardan matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "gujrat": {
    title: "Free Rishta in Gujrat — Verified Profiles | Select Proposal",
    description: "Free rishta in Gujrat. Browse verified Gujrat matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "jhelum": {
    title: "Free Rishta in Jhelum — Verified Profiles | Select Proposal",
    description: "Free rishta in Jhelum. Browse verified Jhelum matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "sahiwal": {
    title: "Free Rishta in Sahiwal — Verified Profiles | Select Proposal",
    description: "Free rishta in Sahiwal. Browse verified Sahiwal matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "larkana": {
    title: "Free Rishta in Larkana — Verified Profiles | Select Proposal",
    description: "Free rishta in Larkana. Browse verified Larkana matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "dera-ghazi-khan": {
    title: "Free Rishta in Dera Ghazi Khan — Verified Profiles",
    description: "Free rishta in Dera Ghazi Khan. Browse verified Dera Ghazi Khan matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "mirpur": {
    title: "Free Rishta in Mirpur — Verified Profiles | Select Proposal",
    description: "Free rishta in Mirpur. Browse verified Mirpur matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "muzaffarabad": {
    title: "Free Rishta in Muzaffarabad — Verified Profiles",
    description: "Free rishta in Muzaffarabad. Browse verified Muzaffarabad matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "wah-cantt": {
    title: "Free Rishta in Wah Cantt — Verified Profiles",
    description: "Free rishta in Wah Cantt. Browse verified Wah Cantt matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "okara": {
    title: "Free Rishta in Okara — Verified Profiles | Select Proposal",
    description: "Free rishta in Okara. Browse verified Okara matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "kasur": {
    title: "Free Rishta in Kasur — Verified Profiles | Select Proposal",
    description: "Free rishta in Kasur. Browse verified Kasur matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "sheikhupura": {
    title: "Free Rishta in Sheikhupura — Verified Profiles",
    description: "Free rishta in Sheikhupura. Browse verified Sheikhupura matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "rahim-yar-khan": {
    title: "Free Rishta in Rahim Yar Khan — Verified Profiles",
    description: "Free rishta in Rahim Yar Khan. Browse verified Rahim Yar Khan matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "mingora": {
    title: "Free Rishta in Mingora — Verified Profiles | Select Proposal",
    description: "Free rishta in Mingora. Browse verified Mingora matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "mansehra": {
    title: "Free Rishta in Mansehra — Verified Profiles",
    description: "Free rishta in Mansehra. Browse verified Mansehra matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "nawabshah": {
    title: "Free Rishta in Nawabshah — Verified Profiles",
    description: "Free rishta in Nawabshah. Browse verified Nawabshah matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "jhang": {
    title: "Free Rishta in Jhang — Verified Profiles | Select Proposal",
    description: "Free rishta in Jhang. Browse verified Jhang matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "chiniot": {
    title: "Free Rishta in Chiniot — Verified Profiles | Select Proposal",
    description: "Free rishta in Chiniot. Browse verified Chiniot matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "kohat": {
    title: "Free Rishta in Kohat — Verified Profiles | Select Proposal",
    description: "Free rishta in Kohat. Browse verified Kohat matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
  "bannu": {
    title: "Free Rishta in Bannu — Verified Profiles | Select Proposal",
    description: "Free rishta in Bannu. Browse verified Bannu matrimonial profiles by education, profession, age and family background. No fee to browse.",
  },
};

const KEYWORD_META = {
  "arain-rishta": {
    title: "Arain Rishta — Verified Proposals, Free to Browse",
    description: "Browse verified Arain rishta proposals from Lahore, Faisalabad, Sahiwal and across Punjab. Real families, manually reviewed profiles, free to browse.",
  },
  "mughal-rishta": {
    title: "Mughal Rishta — Verified Proposals, Free to Browse",
    description: "Free Mughal rishta proposals. Browse verified profiles from Rawalpindi, Islamabad, Gujrat, Jhelum and overseas with education and family details.",
  },
  "awan-rishta": {
    title: "Awan Rishta — Verified Proposals, Free to Browse",
    description: "Free Awan rishta proposals. Browse verified profiles from Chakwal, Attock, Rawalpindi, Jhelum and overseas with education and family details.",
  },
  "gujjar-rishta": {
    title: "Gujjar Rishta — Verified Proposals, Free to Browse",
    description: "Free Gujjar rishta proposals. Browse verified profiles from Gujrat, Gujranwala, Hazara, Azad Kashmir and overseas with education and family details.",
  },
  "malik-rishta": {
    title: "Malik Rishta — Verified Proposals, Free to Browse",
    description: "Free Malik rishta proposals. Browse verified profiles from Rawalpindi, Chakwal, Mianwali, DG Khan and overseas with education and family details.",
  },
  "butt-rishta": {
    title: "Butt Rishta — Verified Proposals, Free to Browse",
    description: "Free Butt and Kashmiri rishta proposals. Browse verified profiles from Lahore, Sialkot, Gujranwala, Faisalabad and overseas with family details.",
  },
  "chaudhary-rishta": {
    title: "Chaudhary Rishta — Verified Proposals, Free to Browse",
    description: "Free Chaudhary rishta proposals. Browse verified profiles from Gujrat, Mandi Bahauddin, Jhelum, Gujranwala and the UK with education and family details.",
  },
  "rajput-rishta": {
    title: "Rajput Rishta — Verified Proposals, Free to Browse",
    description: "Free Rajput rishta proposals. Browse verified profiles from across Punjab, Sindh and overseas with education and family details listed.",
  },
  "jatt-rishta": {
    title: "Jatt Rishta — Verified Proposals, Free to Browse",
    description: "Free Jatt rishta proposals. Browse verified profiles from across Punjab and overseas with education, profession and family details.",
  },
  "syed-rishta": {
    title: "Syed Rishta — Verified Proposals, Free to Browse",
    description: "Free Syed rishta proposals. Browse verified profiles from across Pakistan and overseas with sect, education and family details listed.",
  },
  "pathan-rishta": {
    title: "Pathan Rishta — Verified Proposals, Free to Browse",
    description: "Free Pathan rishta proposals. Browse verified profiles from Peshawar, Mardan, Swat and across KP with education and family details.",
  },
  "sheikh-rishta": {
    title: "Sheikh Rishta — Verified Proposals, Free to Browse",
    description: "Free Sheikh rishta proposals. Browse verified profiles from Lahore, Karachi, Faisalabad and overseas with education and family details.",
  },
  "sunni-rishta": {
    title: "Sunni Rishta — Verified Proposals, Free to Browse",
    description: "Browse verified Sunni rishta proposals from across Pakistan and overseas. Sect listed on every profile. Manually reviewed, free to browse.",
  },
  "shia-rishta": {
    title: "Shia Rishta — Verified Proposals, Free to Browse",
    description: "Browse verified Shia rishta proposals from across Pakistan and overseas. Sect listed on every profile. Manually reviewed, free to browse.",
  },
  "doctor-rishta": {
    title: "Doctor Rishta — Verified MBBS & Specialist Profiles",
    description: "Free doctor rishta proposals. Browse verified MBBS, specialist and lady doctor matrimonial profiles by city, education and family background.",
  },
  "engineer-rishta": {
    title: "Engineer Rishta — Verified Engineer Profiles, Free",
    description: "Free engineer rishta proposals. Browse verified software, civil, mechanical and electrical engineer profiles by city and family background.",
  },
  "educated-rishta": {
    title: "Educated Rishta — Graduate & Professional Matches",
    description: "Free educated rishta proposals. Browse verified graduate and professional matrimonial profiles matched on qualification, career and values.",
  },
  "army-rishta": {
    title: "Army Rishta — Verified Armed Forces Profiles, Free",
    description: "Free army rishta proposals. Browse verified Pakistan Army, Navy and Air Force matrimonial profiles by rank, city and family background.",
  },
  "pakistani-rishta": {
    title: "Pakistani Rishta Online — Free Verified Rishtay",
    description: "Browse Pakistani rishtay free. Verified proposals from every city with education, profession, age and family details. Manually reviewed, no agent.",
  },
  "muslim-matrimony": {
    title: "Muslim Matrimony — Free Verified Profiles in Pakistan",
    description: "Free Muslim matrimony service. Browse verified profiles with family-focused matching, complete privacy and no fee to browse.",
  },
  "overseas-pakistani-rishta": {
    title: "Overseas Pakistani Rishta — Free Verified Proposals",
    description: "Free rishta proposals for overseas Pakistanis in the UK, USA, Canada, UAE and Australia. Verified profiles with full family details.",
  },
  "uk-pakistani-rishta": {
    title: "Pakistani Rishtay in UK — Free Verified Profiles",
    description: "Pakistani rishta in London, Birmingham, Manchester and Bradford. Verified UK and Pakistan profiles with family details. Free to browse, no agent fee.",
  },
  "usa-pakistani-rishta": {
    title: "Pakistani Rishtay in USA — Free Verified Profiles",
    description: "Pakistani rishta in New York, Texas, California, Illinois and Houston. Verified USA and Pakistan profiles with family details. Free to browse.",
  },
  "canada-pakistani-rishta": {
    title: "Pakistani Rishtay in Canada — Free Verified Profiles",
    description: "Zaroorat e rishta for Pakistanis in Toronto, Mississauga, Calgary and Vancouver. Verified Canada and Pakistan profiles with family details. Free to browse.",
  },
  "australia-pakistani-rishta": {
    title: "Australia Pakistani Rishta — Free Verified Profiles",
    description: "Free rishta for Pakistanis in Sydney, Melbourne, Perth and Brisbane. Verified Australia and Pakistan profiles with family details.",
  },
  "saudi-arabia-pakistani-rishta": {
    title: "Saudi Arabia Pakistani Rishta — Free Verified Profiles",
    description: "Free rishta for Pakistanis in Riyadh, Jeddah and Dammam. Verified Saudi Arabia and Pakistan profiles with family and career details.",
  },
  "dubai-pakistani-rishta": {
    title: "Pakistani Rishtay in Dubai & UAE — Free to Browse",
    description: "Pakistani rishta in Dubai, Abu Dhabi, Sharjah and Ajman. Verified UAE and Pakistan profiles with family, visa status and career details. Free to browse.",
  },
  "free-rishta": {
    title: "Free Rishta in Pakistan — Browse Verified Profiles Free",
    description: "Browse verified rishta proposals in Pakistan free. Free registration, free profile listing, no payment to search. Manually reviewed profiles.",
  },
  "free-rishta-islamabad": {
    title: "Free Rishta in Islamabad — Browse Verified Profiles Free",
    description: "Free rishta proposals in Islamabad. Browse verified profiles from Islamabad and Rawalpindi free. Free registration, educated families.",
  },
  "free-rishta-karachi": {
    title: "Free Rishta in Karachi — Browse Verified Profiles Free",
    description: "Free rishta proposals in Karachi. Browse verified profiles across Karachi free — no payment to search. Urdu-speaking, Sindhi & overseas families.",
  },
  "free-rishta-lahore": {
    title: "Free Rishta in Lahore — Browse Verified Profiles Free",
    description: "Free rishta proposals in Lahore. Browse verified profiles across Lahore free. Free registration, free listing, manually reviewed families.",
  },
  "free-rishta-rawalpindi": {
    title: "Free Rishta in Rawalpindi — Browse Verified Profiles Free",
    description: "Free rishta proposals in Rawalpindi. Browse verified profiles from Pindi and Islamabad free. Free registration and free profile listing.",
  },
  "free-rishta-peshawar": {
    title: "Free Rishta in Peshawar — Browse Verified Profiles Free",
    description: "Free rishta proposals in Peshawar. Browse verified Pashtun and Hindko family profiles free. Free registration, privacy respected.",
  },
  "free-rishta-faisalabad": {
    title: "Free Rishta in Faisalabad — Browse Verified Profiles Free",
    description: "Free rishta proposals in Faisalabad. Browse verified profiles across Faisalabad free. Free registration and free profile listing.",
  },
  "free-rishta-gujranwala": {
    title: "Free Rishta in Gujranwala — Browse Verified Profiles Free",
    description: "Free rishta proposals in Gujranwala. Browse verified profiles free — safer than WhatsApp groups. Free registration, manually reviewed.",
  },
  "free-rishta-multan": {
    title: "Free Rishta in Multan — Browse Verified Profiles Free",
    description: "Free rishta proposals in Multan. Browse verified profiles from Multan and south Punjab free. Free registration and free profile listing.",
  },
};

/**
 * Blog title/description overrides, keyed by slug.
 *
 * Blog posts live in the database, so their editorial <h1> titles are long by
 * design ("Haq Mehr in Pakistan 2026: Normal Mahr Amount, Sharia Rules &
 * Family Agreements"). Google truncates those at ~60 chars, which is why the
 * highest-impression blogs had 0.5-2.9% CTR while ranking on page 1.
 * Add an entry here to control the SERP title/description without touching the
 * on-page heading. Optional `faqs` emit FAQPage schema for rich results.
 *
 * Consumed by SingleBlogPage.js and scripts/generate-static-pages.js.
 */
const BLOG_META = {
  "first-meeting-after-rishta-dos-and-don-ts-for-pakistani-families": {
    title: "First Meeting After Rishta — Dos and Don'ts",
    description:
      "What happens at the first rishta meeting, who attends, what to ask, what not to ask, and how Pakistani families move from meeting to baat pakki.",
    faqs: [
      {
        q: "Who attends the first rishta meeting?",
        a: "Usually the parents of both sides with the prospective bride and groom present, and often one or two close elders. Large gatherings are avoided so the two people can actually speak.",
      },
      {
        q: "What should you ask in a first rishta meeting?",
        a: "Practical, respectful questions: education and work, where the couple would live, expectations about the bride's work or study, family responsibilities, and religious practice. Money demands and dowry talk are best avoided at a first meeting.",
      },
      {
        q: "How long should families take to decide?",
        a: "There is no rule, but a week or two is normal. Pressure to answer on the same day is a warning sign, not a compliment.",
      },
    ],
  },
  "nikah-nama-in-pakistan-what-every-clause-means-clauses-18-19-20-explained-before-you-sign": {
    title: "Nikah Nama Clause 18, 19 & 20 — What They Mean",
    description:
      "Clause 18, 19 and 20 of the nikah nama in plain words: delegated divorce, agreed conditions, and what you lose if they are struck out before signing.",
    faqs: [
      {
        q: "What is clause 18 of the nikah nama?",
        a: "Clause 18 records any special conditions the couple agree as part of the marriage contract, such as residence, continuing education or the wife's work. Conditions written here are legally part of the contract.",
      },
      {
        q: "What is clause 19 (talaq-e-tafweez)?",
        a: "Clause 19 is delegated divorce: the husband may delegate the right of divorce to the wife. If it is filled in, she can end the marriage herself on the terms recorded. If it is struck out, she must go through khula in court.",
      },
      {
        q: "Should these clauses ever be left blank or crossed out?",
        a: "Leaving them blank or crossing them out is common but it removes protections from the wife. Both families should read clauses 13 to 20 before signing, since a registered nikah nama is hard to change later.",
      },
    ],
  },
  "haq-mehr-in-pakistan-2026-normal-mahr-amount-sharia-rules-family-agreements": {
    title: "Haq Mehr Amount in Pakistan 2026 — Sharia Rules",
    description:
      "What haq mehr amounts are normal in Pakistan, what Sharia actually requires, prompt vs deferred mehr, and how families record it in the nikah nama.",
    faqs: [
      {
        q: "Is there a fixed haq mehr amount in Islam?",
        a: "No. Islam sets no fixed amount. The mehr is agreed between the bride and groom and must be something of real value that the groom can genuinely pay. The bride's consent to the amount is what matters.",
      },
      {
        q: "What is the difference between prompt and deferred haq mehr?",
        a: "Prompt (mu'ajjal) mehr is payable at the time of nikah. Deferred (mu'wajjal) mehr is payable later, at a date or event written into the nikah nama. The nikah nama has separate columns for both, and how they are filled in decides when the bride can claim it.",
      },
      {
        q: "Where is haq mehr recorded in Pakistan?",
        a: "In the nikah nama, which is registered with the union council. Columns 13 to 16 cover the mehr amount, how much was paid at the time of nikah, and any property given in place of cash. Leaving them blank or writing a token figure is the most common cause of later disputes.",
      },
    ],
  },
  "gheerah-and-healthy-boundaries-what-islam-says-about-jealousy-in-marriage": {
    title: "Gheerah Meaning in Islam — Care or Jealousy?",
    description:
      "Gheerah means protective care over a spouse's honour — not suspicion. Read the meaning, the difference from jealousy, and where the healthy line sits.",
    faqs: [
      {
        q: "What does gheerah mean?",
        a: "Gheerah is the protective sense a person has over their spouse's honour and dignity. In the Islamic tradition it is praised as care and responsibility, not as suspicion or surveillance of a spouse.",
      },
      {
        q: "Is jealousy the same thing as gheerah?",
        a: "No. Gheerah protects the other person; jealousy tries to control them. Checking a spouse's phone, restricting normal family contact and constant accusation are signs of insecurity, not of gheerah.",
      },
      {
        q: "How do couples set healthy boundaries?",
        a: "By agreeing the boundaries openly before marriage rather than enforcing them afterwards, and by discussing family contact, work, social media and privacy as shared decisions instead of one person's rules.",
      },
    ],
  },
  "pakistani-wedding-traditions-from-rishta-to-rukhsati-complete-guide": {
    title: "Baat Pakki, Mangni, Rukhsati — What Each Means",
    description:
      "What baat pakki, mangni, mayun, mehndi, nikah, rukhsati and walima each mean, in order, and who arranges what at every stage of a Pakistani wedding.",
    faqs: [
      {
        q: "What is the order of events in a Pakistani wedding?",
        a: "Typically rishta (the proposal), baat pakki (the families' agreement), mangni (engagement), mayun and mehndi, then the nikah, rukhsati and finally the walima hosted by the groom's family.",
      },
      {
        q: "What is the difference between nikah and rukhsati?",
        a: "The nikah is the marriage contract itself, and it makes the couple married. Rukhsati is the bride leaving her parents' home for the groom's. They often happen on the same day, but many families hold them weeks or months apart.",
      },
      {
        q: "Which events are religiously required?",
        a: "Only the nikah, with offer, acceptance, witnesses and mehr. Mayun, mehndi and the scale of the walima are cultural customs, and families are free to reduce or skip them.",
      },
    ],
  },
  "nadra-marriage-certificate-in-pakistan-2026-step-by-step-guide-to-apply-union-council-process-fee-required-documents": {
    title: "Computerised Nikah Nama Fee 2026 & NADRA Steps",
    description:
      "Union council and NADRA fees for a computerised nikah nama in 2026, the documents required, and each step to get the NADRA marriage certificate.",
    faqs: [
      {
        q: "Is a nikah nama the same as a NADRA marriage certificate?",
        a: "No. The nikah nama is the contract completed by the nikah registrar. The NADRA marriage certificate (MRC) is a computerised record issued after the nikah nama is registered with the relevant union council.",
      },
      {
        q: "What documents are needed?",
        a: "The registered nikah nama, CNICs of both spouses, and CNICs of the witnesses. Requirements vary slightly by union council and by NADRA centre, so confirm locally before travelling.",
      },
      {
        q: "Why do visa and immigration applications ask for it?",
        a: "Because the NADRA certificate is machine-readable and verifiable against national records, which foreign missions accept as proof of marriage. A nikah nama alone is often refused for spouse visa and family reunification cases.",
      },
    ],
  },
};

const HOME_META = {
  title: "Select Proposal — Pakistan's Most Trusted Rishta Service",
  description: "Find your rishta on Select Proposal. Verified profiles, filters by education, profession, city and family values. Free to browse, register free.",
};


module.exports = { CITY_META, KEYWORD_META, BLOG_META, HOME_META };
